export const CycleMilestoneType = {
    PROJECT_KICK_OFF: 'ProjectKickOff',
    MANAGER_DEADLINE: 'ManagerDeadline',
    DISCUSSION_EMAIL: 'DiscussionEmail',
    EVALUATION_CYCLE_CLOSURE: 'EvaluationCycleClosure',
} as const;

export type CycleMilestoneTypeValue = (typeof CycleMilestoneType)[keyof typeof CycleMilestoneType];
